module.exports = __webpack_public_path__ + "img/tire_storage.4f2dcff1.svg";